/* eslint-disable react/prefer-es6-class */
import React from 'react';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export const SentenceTrainerHelpPanel = React.createClass({
  displayName: 'SentenceTrainerHelpPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('shortcut keys');
    },
  },

  render() {
    return (
      <div className="help-block">
        <div className="keyboard-explanation">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key long-key">
                      <div className="top-left text">Enter</div>
                      <div className="bottom-right text">↲</div>
                    </div>
                  </div>
                  <div className="explanation">{t('help-panel.sentence-trainer.enter')}</div>
                </td>

                <td>
                  <div className="keys">
                    <div className="key long-key">
                      <div className="top-left text">Space</div>
                    </div>
                  </div>
                  <div className="explanation">{t('app_keys.play audio')}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key-wrapper">
                      <div className="key">
                        <div className="arrow">↑</div>
                      </div>
                    </div>
                    <div className="key">
                      <div className="arrow">←</div>
                    </div>
                    <div className="key">
                      <div className="arrow">↓</div>
                    </div>
                    <div className="key">
                      <div className="arrow">→</div>
                    </div>
                  </div>
                  <div className="explanation">{t('select-answer')}</div>
                </td>

                <td>
                  <div className="keys">
                    <div className="key long-key">
                      <div className="top-left text">Shift</div>
                    </div>

                    <div className="key">
                      <div className="arrow">↑</div>
                    </div>
                  </div>
                  <div className="explanation">{t('hint')}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  },
});

export default SentenceTrainerHelpPanel;
